import { FormControl, FormControlLabel, Menu, MenuItem, Radio, RadioGroup } from '@mui/material';
import { useUserThemeContext } from '@src/main/ui/providers/user/UserThemeContextProvider';
import { FC } from 'react';

interface Props {
  anchorElTheme: null | HTMLElement;
  handleCloseTheme: () => void;
}

const ThemeMenu: FC<Props> = ({ anchorElTheme, handleCloseTheme }) => {
  const { theme, themes, setTheme } = useUserThemeContext();

  return (
    <Menu
      id="menu-theme"
      anchorEl={anchorElTheme}
      anchorOrigin={{
        vertical: 'top',
        horizontal: 'left',
      }}
      keepMounted
      transformOrigin={{
        vertical: 'center',
        horizontal: 'right',
      }}
      open={Boolean(anchorElTheme)}
      onClose={handleCloseTheme}
    >
      <FormControl>
        <RadioGroup value={theme}>
          {themes.map((themeValue) => (
            <MenuItem
              key={themeValue}
              onClick={() => {
                setTheme(themeValue);
              }}
            >
              <FormControlLabel
                key={themeValue}
                value={themeValue}
                control={<Radio />}
                label={themeValue}
              />
            </MenuItem>
          ))}
        </RadioGroup>
      </FormControl>
    </Menu>
  );
};

export default ThemeMenu;
